import { render, staticRenderFns } from "./GenderStep.vue?vue&type=template&id=55da90f5"
import script from "./GenderStep.vue?vue&type=script&lang=js"
export * from "./GenderStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports